module.exports = __webpack_public_path__ + "static/python-8bfdfc7d2c1b8038648dd5e663712bb0.png";